import ModalPaymentStatusMobile from './ModalPaymentStatusMobile';

export default ModalPaymentStatusMobile;
